module.exports = require("@swa-ui/dotcom/src/DotcomHeader/DotcomHeaderMobile/Copyright.module.scss");